import FormPropertyProfile from './FormPropertyProfile';

export default FormPropertyProfile;
